function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeechtotextBro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.91,351.46a42.4,42.4,0,0,0-5.81,2.36c-4.83,2.34-11.58,6.57-15.91,13.27-3.87,6-5.81,14-2.71,24.31H171l-2.75-82.3,15.24-18.58c7,4,12.74,13.67,14.64,24.63S205.91,351.46,205.91,351.46Z",
    style: {
      fill: "#FAAE17",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.94,325.14l-14.86-1.65a2.1,2.1,0,0,1-1.77-2.92l18.4-42.44a4.38,4.38,0,0,1,4.35-2.63l14.85,1.65a2.09,2.09,0,0,1,1.77,2.91L241.29,322.5A4.41,4.41,0,0,1,236.94,325.14Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.93,167.09s-27.88,72,11.3,144.5S199.11,422.39,263.7,455.14s131.66,16.8,163.53-36.84-11.84-91.93-11.9-168.42,11.45-96.74-30-161.36-143.06-78.93-219.9-31S67.93,167.09,67.93,167.09Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.15,75.07c-23.6-24.92-81.54-15.79-106.63,0C179.06,126.32,36.27,211.64,29.81,335.24c-2.75,52.53,43.58,80.12,62.93,88.21,46.48,19.44,97.48,25.27,147.81,27.52,52.57,2.35,109,.52,156.31-25.13,17.94-9.71,34.86-22.17,46.44-39.18,11.76-17.28,18.53-37.86,20.33-58.63,2.89-33.5-6.12-67.09-19.75-97.83s-31.8-59.2-48.49-88.4C384.51,122.76,387,96.06,367.15,75.07Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.15,75.07c-23.6-24.92-81.54-15.79-106.63,0C179.06,126.32,36.27,211.64,29.81,335.24c-2.75,52.53,43.58,80.12,62.93,88.21,46.48,19.44,97.48,25.27,147.81,27.52,52.57,2.35,109,.52,156.31-25.13,17.94-9.71,34.86-22.17,46.44-39.18,11.76-17.28,18.53-37.86,20.33-58.63,2.89-33.5-6.12-67.09-19.75-97.83s-31.8-59.2-48.49-88.4C384.51,122.76,387,96.06,367.15,75.07Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--sound-bars--inject-74"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 119.59,
    y1: 146.23,
    x2: 119.59,
    y2: 156.53,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 115.87,
    y1: 130.34,
    x2: 115.87,
    y2: 168.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.19,
    y1: 131.4,
    x2: 138.19,
    y2: 169.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 127.03,
    y1: 144.22,
    x2: 127.03,
    y2: 154.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.7,
    y1: 144.22,
    x2: 197.7,
    y2: 154.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.75,
    y1: 141.83,
    x2: 130.75,
    y2: 158.53,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.31,
    y1: 144.17,
    x2: 123.31,
    y2: 160.87,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.47,
    y1: 120.82,
    x2: 134.47,
    y2: 153.39,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.91,
    y1: 144.22,
    x2: 141.91,
    y2: 154.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 145.63,
    y1: 136.76,
    x2: 145.63,
    y2: 159.53,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.39,
    y1: 146.06,
    x2: 175.39,
    y2: 162.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 182.82,
    y1: 134.05,
    x2: 182.82,
    y2: 166.62,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.26,
    y1: 150.45,
    x2: 190.26,
    y2: 160.59,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.27,
    y1: 149.34,
    x2: 97.27,
    y2: 159.48,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.98,
    y1: 145.99,
    x2: 193.98,
    y2: 168.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.51,
    y1: 145.26,
    x2: 160.51,
    y2: 155.42,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 167.95,
    y1: 143.87,
    x2: 167.95,
    y2: 160.57,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 149.35,
    y1: 141.99,
    x2: 149.35,
    y2: 158.69,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.66,
    y1: 136.86,
    x2: 171.66,
    y2: 169.43,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 179.1,
    y1: 145.26,
    x2: 179.1,
    y2: 155.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.54,
    y1: 137.8,
    x2: 186.54,
    y2: 160.57,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 201.42,
    y1: 137,
    x2: 201.42,
    y2: 159.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 153.07,
    y1: 147.1,
    x2: 153.07,
    y2: 164.91,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 205.14,
    y1: 143.61,
    x2: 205.14,
    y2: 161.43,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104.71,
    y1: 141.9,
    x2: 104.71,
    y2: 152.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.55,
    y1: 143.31,
    x2: 93.55,
    y2: 153.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 208.86,
    y1: 143.07,
    x2: 208.86,
    y2: 153.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.99,
    y1: 143.67,
    x2: 100.99,
    y2: 166.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.43,
    y1: 134.68,
    x2: 108.43,
    y2: 157.45,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 112.15,
    y1: 141.29,
    x2: 112.15,
    y2: 159.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.79,
    y1: 127.35,
    x2: 156.79,
    y2: 159.01,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164.23,
    y1: 136.76,
    x2: 164.23,
    y2: 154.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 316.25,
    y1: 414.28,
    x2: 316.25,
    y2: 403.97,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 319.97,
    y1: 430.16,
    x2: 319.97,
    y2: 392.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 297.65,
    y1: 429.1,
    x2: 297.65,
    y2: 391.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 308.81,
    y1: 416.28,
    x2: 308.81,
    y2: 406.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 238.13,
    y1: 416.28,
    x2: 238.13,
    y2: 406.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 305.09,
    y1: 418.67,
    x2: 305.09,
    y2: 401.97,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312.53,
    y1: 416.33,
    x2: 312.53,
    y2: 399.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 301.37,
    y1: 439.69,
    x2: 301.37,
    y2: 407.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 293.93,
    y1: 416.28,
    x2: 293.93,
    y2: 406.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 290.21,
    y1: 423.74,
    x2: 290.21,
    y2: 400.97,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260.45,
    y1: 414.44,
    x2: 260.45,
    y2: 397.74,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 253.01,
    y1: 426.46,
    x2: 253.01,
    y2: 393.88,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.57,
    y1: 410.05,
    x2: 245.57,
    y2: 399.91,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 338.57,
    y1: 411.16,
    x2: 338.57,
    y2: 401.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 241.85,
    y1: 414.51,
    x2: 241.85,
    y2: 391.74,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 275.33,
    y1: 415.24,
    x2: 275.33,
    y2: 405.08,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 267.89,
    y1: 416.63,
    x2: 267.89,
    y2: 399.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 286.49,
    y1: 418.51,
    x2: 286.49,
    y2: 401.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264.17,
    y1: 423.64,
    x2: 264.17,
    y2: 391.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 256.73,
    y1: 415.24,
    x2: 256.73,
    y2: 405.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 249.29,
    y1: 422.7,
    x2: 249.29,
    y2: 399.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 234.41,
    y1: 423.5,
    x2: 234.41,
    y2: 400.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 282.77,
    y1: 413.4,
    x2: 282.77,
    y2: 395.59,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 230.69,
    y1: 416.89,
    x2: 230.69,
    y2: 399.08,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 331.13,
    y1: 418.6,
    x2: 331.13,
    y2: 408.45,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 342.29,
    y1: 417.19,
    x2: 342.29,
    y2: 407.04,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 226.97,
    y1: 417.44,
    x2: 226.97,
    y2: 407.28,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 334.85,
    y1: 416.83,
    x2: 334.85,
    y2: 394.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 327.41,
    y1: 425.82,
    x2: 327.41,
    y2: 403.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 323.69,
    y1: 419.21,
    x2: 323.69,
    y2: 401.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 279.05,
    y1: 433.15,
    x2: 279.05,
    y2: 401.49,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 271.61,
    y1: 423.74,
    x2: 271.61,
    y2: 406.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.43,236.89H193.77a5.26,5.26,0,0,0-5.26,5.26V257.8a30.18,30.18,0,0,1-14.25-4.22s4.05,9.8,14.25,11.7v2.3a5.27,5.27,0,0,0,5.26,5.26h36.66a5.26,5.26,0,0,0,5.26-5.26V242.15A5.25,5.25,0,0,0,230.43,236.89Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.22,253.31H200.9v-8.39h1.32v3.59h1.5v-3.59h1.35v8.39h-1.35v-3.6h-1.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.35,248.45h1.81v1.2h-1.81v2.46h2.28v1.2H206v-8.39h3.6v1.2h-2.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.44,244.92h1.32v7.19h2.17v1.2h-3.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.51,244.92h1.32v7.19H218v1.2h-3.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.47,246.93a2,2,0,1,1,4,0v4.37a2,2,0,1,1-4,0Zm1.32,4.45c0,.6.27.83.69.83s.68-.23.68-.83v-4.53c0-.6-.26-.83-.68-.83s-.69.23-.69.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.52,255.92h4.08v1.2h-1.38v7.19H201.9v-7.19h-1.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.49,264.31h-1.31v-8.39h1.31v3.59H208v-3.59h1.35v8.39H208v-3.6h-1.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.62,259.45h1.81v1.2h-1.81v2.46h2.28v1.2h-3.6v-8.39h3.6v1.2h-2.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.47,264.31a2.6,2.6,0,0,1-.12-1V262c0-.78-.26-1.07-.86-1.07H216v3.42h-1.31v-8.39h2c1.36,0,1.95.63,1.95,1.93v.66a1.66,1.66,0,0,1-.86,1.69v0c.66.28.87.9.87,1.78v1.29a2.49,2.49,0,0,0,.15,1ZM216,257.12v2.57h.52c.49,0,.79-.21.79-.88V258c0-.6-.2-.86-.67-.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.86,259.45h1.81v1.2h-1.81v2.46h2.28v1.2h-3.6v-8.39h3.6v1.2h-2.28Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.89,96.13V378.18a2.87,2.87,0,0,1-2.86,2.87H252.53a2.87,2.87,0,0,1-2.87-2.87v-282a6.56,6.56,0,0,1,6.54-6.54h40.85a3.68,3.68,0,0,1,3.52,2.63,3.64,3.64,0,0,0,1.32,1.9,3.7,3.7,0,0,0,2.2.73h68.37A3.67,3.67,0,0,0,376,92.22a3.6,3.6,0,0,1,1.33-1.9,3.7,3.7,0,0,1,2.2-.73h40.84A6.56,6.56,0,0,1,426.89,96.13Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.66,
    y: 112.4,
    width: 177.23,
    height: 35.3,
    style: {
      fill: "#FAAE17",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.66,
    y: 147.7,
    width: 177.23,
    height: 196.95,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.87,
    y: 354.34,
    width: 12.13,
    height: 12.13,
    rx: 3.3,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.84,339.22h-122a7.7,7.7,0,0,1-7.7-7.7h0a7.7,7.7,0,0,1,7.7-7.7h122a7.7,7.7,0,0,1,7.7,7.7h0A7.7,7.7,0,0,1,387.84,339.22Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.85,332.54h0a2.9,2.9,0,0,1-2.9-2.91v-2a2.9,2.9,0,0,1,2.9-2.9h0a2.89,2.89,0,0,1,2.9,2.9v2A2.9,2.9,0,0,1,412.85,332.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.29,329v.92a4.56,4.56,0,0,0,4.56,4.57h0a4.57,4.57,0,0,0,4.57-4.57V329",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 412.85,
    y1: 334.46,
    x2: 412.85,
    y2: 338.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.53,192.76h-99l-7.53,5V166.85a7.52,7.52,0,0,1,7.52-7.52h99.06a7.52,7.52,0,0,1,7.51,7.52v18.39A7.52,7.52,0,0,1,366.53,192.76Z",
    style: {
      fill: "#FAAE17",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 409.05,
    y1: 124.97,
    x2: 417.76,
    y2: 124.97,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 409.05,
    y1: 129.75,
    x2: 417.76,
    y2: 129.75,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 409.05,
    y1: 134.53,
    x2: 417.76,
    y2: 134.53,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.88,129H286.6a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2h29.28a2,2,0,0,1,2,2h0A2,2,0,0,1,315.88,129Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.35,133.86H285.68a1.06,1.06,0,0,1-1.05-1.06h0a1,1,0,0,1,1.05-1.05h41.67a1.06,1.06,0,0,1,1.06,1.05h0A1.07,1.07,0,0,1,327.35,133.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.48,
    cy: 129.75,
    r: 10.88,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.93,136.54c-.66,0-2.59-1.45-1.93-2.64s1.93-3.16,1.93-3.16a8.56,8.56,0,0,0,.92-3.56c.26-1.85-.79-5-5.37-5s-5.64,3.16-5.38,5a8.56,8.56,0,0,0,.92,3.56s1.27,2,1.93,3.16-1.27,2.64-1.93,2.64a17.31,17.31,0,0,0-3.12,1s4.38,3.08,7.58,3.08,7.57-3.08,7.57-3.08A17.31,17.31,0,0,0,271.93,136.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.97,
    y: 126.9,
    width: 10.11,
    height: 7.06,
    rx: 1.19,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.28 131.82 360.77 132.61 360.77 128.25 362.28 129.04 362.28 131.82",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.81,130.87l-3.56,3.56a3.07,3.07,0,0,1-4.34,0l-1-1,2.61-2.62,1.79,1.79,2.68-2.68-1.79-1.79,2.62-2.61,1,1A3.08,3.08,0,0,1,394.81,130.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390.82,
    cy: 130.43,
    r: 8.49,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.92,
    cy: 130.43,
    r: 8.49,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.6,
    y: 104.53,
    width: 1.98,
    height: 4.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.24,
    y: 102.9,
    width: 1.98,
    height: 5.68,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.87,
    y: 101.26,
    width: 1.98,
    height: 7.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.51,
    y: 99.63,
    width: 1.98,
    height: 8.95,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.6,
    y: 100.45,
    width: 13.04,
    height: 7.31,
    rx: 1.19,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.17,102h1a1,1,0,0,1,1,1v2.3a1,1,0,0,1-1,1h-1a0,0,0,0,1,0,0V102A0,0,0,0,1,276.17,102Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.63,182.48h-2.22V168.37h2.22v6h2.52v-6h2.26v14.11h-2.26v-6h-2.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.24,174.32h3v2h-3v4.13h3.83v2H281V168.37h6.05v2h-3.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.44,168.37h2.22v12.09h3.64v2h-5.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.27,168.37h2.22v12.09h3.65v2h-5.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.93,171.76c0-2.26,1.19-3.55,3.36-3.55s3.37,1.29,3.37,3.55v7.33c0,2.26-1.19,3.55-3.37,3.55s-3.36-1.29-3.36-3.55Zm2.21,7.47c0,1,.45,1.39,1.15,1.39s1.15-.38,1.15-1.39v-7.62c0-1-.44-1.39-1.15-1.39s-1.15.39-1.15,1.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.57,168.37h6.85v2H317.1v12.1h-2.21v-12.1h-2.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.61,182.48h-2.22V168.37h2.22v6h2.52v-6h2.25v14.11h-2.25v-6h-2.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.21,174.32h3.05v2h-3.05v4.13H335v2h-6V168.37h6v2h-3.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.05,182.48a4.37,4.37,0,0,1-.2-1.73v-2.22c0-1.31-.44-1.8-1.45-1.8h-.77v5.75h-2.21V168.37h3.34c2.3,0,3.29,1.07,3.29,3.24v1.11a2.81,2.81,0,0,1-1.45,2.85v0c1.11.46,1.47,1.51,1.47,3v2.18a4.17,4.17,0,0,0,.24,1.71Zm-2.42-12.1v4.34h.87c.83,0,1.33-.36,1.33-1.49v-1.39c0-1-.34-1.46-1.13-1.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.74,174.32h3v2h-3v4.13h3.83v2h-6.05V168.37h6.05v2h-3.83Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.16,341.46l4.75,21,2.58,31.79s-8.67,7.05-18.68,2.69-20.71-39.56-20.71-39.56",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.91,351.46a42.4,42.4,0,0,0-5.81,2.36c-4.83,2.34-11.58,6.57-15.91,13.27-3.87,6-5.81,14-2.71,24.31H171l-2.75-82.3,15.24-18.58c7,4,12.74,13.67,14.64,24.63S205.91,351.46,205.91,351.46Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-74)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.1,353.82c-4.83,2.34-11.58,6.57-15.91,13.27l1.1-34.64s7.72,7.65,9.38-14.79c0,0,1.7,11.17,0,15.56l3.41,2.35-3.41,12.74A24.71,24.71,0,0,1,200.1,353.82Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M205.91,351.46a42.4,42.4,0,0,0-5.81,2.36c-4.83,2.34-11.58,6.57-15.91,13.27-3.87,6-5.81,14-2.71,24.31H171l-2.75-82.3,15.24-18.58c7,4,12.74,13.67,14.64,24.63S205.91,351.46,205.91,351.46Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.08,367.55c8.23-13.83,26.11-23.94,37.89-39.61,4.65-6.17.28-20.25,15.51-26.74,0,0,3.21,1.08,4.47,15.61a31.73,31.73,0,0,1-4.17,18.07c-17.82,27.57-23.44,52.49-46.26,60.55",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.09,448.2c-36.85-3.58-73.31-10.51-107.35-24.75-1.36-.57-2.85-1.23-4.45-2-.35-3-.8-6-1.32-9-1.87-10.86-4.7-21.91-7.69-32.81-10.4-37.94-22.64-74-2.42-94,0,0,6.81-5.88,31.73-13.07,0,0,.31-6,16.9-4.75,26.62,2,33.92,10,33.92,10,15.5,4.82,24,12.79,24,12.79l5.8,22.89c2.21,10.35,4.15,22.33,3.94,31.68C192.77,363.35,198.65,431.85,200.09,448.2Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.28,374.17l-4.86.26c-3.4-17.47-.78-34.92-4.69-52.4l4.88.08C128.51,339.48,125.93,356.82,129.28,374.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.1,381.13l-4.74.3c-5.25-17.22-2.86-34.58-5.17-51.86l4.79,0C135.28,346.77,132.93,364,138.1,381.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.36,374.14l-4.69.26c-3.4-17.14-.91-34.28-4.61-51.43l4.7.07C142.45,340.09,140,357.11,143.36,374.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.7,380.28l-4.57.29c-5-16.92-2.73-34-5-50.92l4.61,0C149,346.54,146.77,363.46,151.7,380.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.2,375.42l-4.51.25c-3.72-16.81-1.35-33.65-4.56-50.48l4.53.05C155.86,342,153.53,358.7,157.2,375.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.56,368.27l-4.44.21c-2.23-16.7-.08-33.32-5-50.07l4.45.09C162.47,335.15,160.36,351.67,162.56,368.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.22,379.05l-4.33.27c-4.69-16.47-2.55-33.05-4.86-49.56l4.37,0C168.71,346.2,166.61,362.67,171.22,379.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.44,374.32l-4.27.25c-3.48-16.38-1.28-32.77-4.46-49.15l4.3.05C175.18,341.75,173,358.05,176.44,374.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.14,371.37l-4.21.22c-2.84-16.25-.71-32.47-4.48-48.74l4.22.07C181.43,339.09,179.34,355.21,182.14,371.37Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M131.87,319.81c-.36,1.27-24,82-31.55,88.17-4.16,3.38-9.43,4.31-13.35,4.45-1.87-10.86-4.7-21.91-7.69-32.81-1.06-26.11-.78-58.32,7.13-57.59,13.25,1.24,14.17,17.57,14.17,17.57Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.44,307.16s4.18,15.86.76,23.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.29,421.46c-6-51.11-39.08-108.52-11.43-135.87,0,0,6.81-5.88,31.73-13.07,0,0,.31-6,16.9-4.75,26.62,2,33.92,10,33.92,10,15.5,4.82,24,12.79,24,12.79",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.24,313.41c2.21,10.35,4.15,22.33,3.94,31.68-.41,18.26,5.47,86.76,6.91,103.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.36,279s11.77,14.61,29.93,14.61,18.85-7.78,18.85-7.78",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.13,343.38C159,364,140,383,116.14,389.43",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.33,333.22c-1.18,2.17-2.46,4.29-3.76,6.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.25,410.21c11.66,9.46,25.14,17.15,39.74,20.93a74.29,74.29,0,0,0,15.34,2.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.85,402.63c1.68,1.74,3.48,3.38,5.31,5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.54,272.68a50,50,0,0,0,.74,10.57c-21.88,12.51-41.43-12.94-41.43-12.94s6.2-6.55,7.32-21.81c.34-4.66-5.1-24.13-5.1-24.13s18.37-1.06,28.42,10.66a73.27,73.27,0,0,1,8,11.68A105.71,105.71,0,0,1,160,263.38C156.09,263.76,154.8,268.14,154.54,272.68Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,263.38c-3.92.38-5.21,4.76-5.47,9.3-21.17-5.29-22.67-21.37-22.67-21.37l20.63-4.6A105.71,105.71,0,0,1,160,263.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.42,194.76s3.3,20-3.22,30.41-15.38-32.25-15.38-32.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.53,239.91a24.69,24.69,0,0,1-4-7.88c-4.9-17-2.64-41.84,21.1-44.8,15.29-1.91,33.61,8.84,37.92,29.76,1.06,5.14-.2,12-.2,12s.61,7.58-.3,11.39c-3.54,14.71-9.54,27.72-12.73,28.22-13.67,2.13-27.24-7-28.7-10a27.74,27.74,0,0,1-1.78-4.29",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.73,222.52s-9.09-1.71-12.87,1.58",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.38,221.08s5.79-2,8.72.8",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.05,224.2s-.74,6-.19,8.4,2.68,8.77,3,11.44c.52,4.27-9.26,1.9-9.48.08",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.92,232c.12,1-.36,1.83-1.06,1.92s-1.37-.64-1.49-1.61.35-1.83,1-1.92S148.8,231,148.92,232Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.37,230.32c.12,1-.36,1.83-1.06,1.92s-1.37-.63-1.49-1.61.35-1.83,1.06-1.91S168.25,229.35,168.37,230.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,251.31a52.63,52.63,0,0,1-13.23.65s1.93,5.18,6.32,5.75c6.83.89,5.44-4.8,5.44-4.8",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.26,231.38l5.16-1.68s-1.59-8.37,4.48-14.57L135.17,204s25.58-7.42,37,1.61l1.27-10.82s-11.49-12.63-40.69-8.11S109.05,232,119.81,247.31l5.72-5.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.47,231.79S127.66,224,125,224s-6.09,2.6-5.48,5.61,1.14,11.2,2.2,11.8,4.41,2.91,5.14,4.3,2.94.25,2.65-1.07",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.24,323.37l-13.89-.06c-1.44-.1-3.3-3.18-2.73-4.51L237,276.37a4.4,4.4,0,0,1,4.35-2.64l14.86,1.65c1.43.1,4.23,2.8,3.66,4.12l-20.29,41.23A4.4,4.4,0,0,1,235.24,323.37Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.94,325.14l-14.86-1.65a2.1,2.1,0,0,1-1.77-2.92l18.4-42.44a4.38,4.38,0,0,1,4.35-2.63l14.85,1.65a2.09,2.09,0,0,1,1.77,2.91L241.29,322.5A4.41,4.41,0,0,1,236.94,325.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-74)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.94,325.14l-14.86-1.65a2.1,2.1,0,0,1-1.77-2.92l18.4-42.44a4.38,4.38,0,0,1,4.35-2.63l14.85,1.65a2.09,2.09,0,0,1,1.77,2.91L241.29,322.5A4.41,4.41,0,0,1,236.94,325.14Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M236.94,325.14l-14.86-1.65a2.1,2.1,0,0,1-1.77-2.92l18.4-42.44a4.38,4.38,0,0,1,4.35-2.63l14.85,1.65a2.09,2.09,0,0,1,1.77,2.91L241.29,322.5A4.41,4.41,0,0,1,236.94,325.14Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.92,287.88l-2.4-.27a.33.33,0,0,1-.28-.47l3-6.84a.71.71,0,0,1,.7-.43l2.4.27a.34.34,0,0,1,.29.47l-3,6.84A.71.71,0,0,1,240.92,287.88Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,316.32c2.6-5.94.11-17-3.59-18.26s-17.93,3.66-17.93,3.66c-5.43,1.69-4.28,5.44-4.28,5.44-3.14.83-4.62,2.89-3.8,4.35.91,1.64,4.91,1.65,4.91,1.65s-4.66,1.48-4.18,3.14c1.13,3.92,9.8,2.17,9.8,2.17s-5.14,1.36-5.08,2c.42,4,8.66,2.27,8.66,2.27l4,4.1a4.37,4.37,0,0,0,3,5.64",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.23,307.16s12.87-3.28,14.26-3,6.65.85,6.65.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.34,313.16s10.08-1.54,11.65-1a62.28,62.28,0,0,0,7.42,1.14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,318.47a22.68,22.68,0,0,1,3.81-.81c1,0,6.15,2.07,6.15,2.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.56,362.45c1.76,4.12,3.13,8.18,11.44,9.36S101.19,359.74,94.7,340s-28.22-4.63-32,3.65S59,358.82,60.56,362.45Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.55,328.3,99.1,364.63l-26.95,30.8s-8.85-4.63-10.84-42.3",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.86,285.59s-13.24,7.73-15.55,19.65-4.39,45.31-.75,57.21c0,0,3.58-11.06,10.51-17.36S94.7,340,94.7,340l-3.5-15.63s-.08-15.24-14.55-27",
    style: {
      fill: "#FAAE17",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,389.15c4.48,11.61,17.24,14.21,34.28-3.42,8.12-8.4,36.81-79.65,36.81-79.65l-14.63-8.78s-26.09,41.12-38.26,52.18a77,77,0,0,0-9.21,10",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.46,264.44s3.95-9.85,6.06-10.6,2.66.18,2.78,2-4.42,18.33-4.42,18.33L131.13,279Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.85,230c-2.32.12-1.07,8.5.64,9.19a12.44,12.44,0,0,0,3.56.78s4.54,9.6,13.13,14.78a1.3,1.3,0,0,0,1.91-.66h0a1.29,1.29,0,0,0-.52-1.55c-2.1-1.3-7.46-5.27-12.19-14.19C129.38,238.36,130.52,229.63,122.85,230Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.29,308a42,42,0,0,0,7.18-6.24c4.55-4.65,4.05-15.87,4.84-15.92,3.53-.19,3.49-8.56,2.28-11.67s-2.28-2.89-2.28-2.89c-1.24-4.47-4.84-4.47-4.84-4.47s-1.52-3-3.71-2.33a50.83,50.83,0,0,0-7,3.36l1.23-7.37s2.72-6.08,3.71-9.12-1.58-3.5-1.58-3.5-6.4,7.85-7.59,9.83-3.49,11.55-3.49,11.55l-2.9,30.91",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 145.47,
    y1: 266.83,
    x2: 139.07,
    y2: 270.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.31,271.3c-1.61-1.06-6.09,2.89-6.09,2.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.31,285.86l-1.24-6.26a2.59,2.59,0,0,1,2.14,1.58",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.41,301.2A29,29,0,0,1,90,317.3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechtotextBro);
export default __webpack_public_path__ + "static/media/Speech to text-bro.b2eec4c055291d9329627321d2d38bfe.svg";
export { ForwardRef as ReactComponent };